import React from "react";
import { answerText } from "./item-list-model";
export default function SurveySnapshot({ result }) {
  const definition = result.definition_snapshot;
  if (!definition) return null;
  return <div>
    <p className="secondary">Submitted form: {definition.name}. Shown as it was when submitted.</p>
    {result.context_snapshot && <p>{result.context_snapshot.property} · Arrival: {String(result.context_snapshot.check_in || "").slice(0, 10)}</p>}
    {definition.intro && <p style={{ whiteSpace: "pre-wrap" }}>{definition.intro}</p>}
    {definition.questions.map((q) => {
      const answer = (result.answers || []).find((a) => String(a.survey_question_id) === String(q.survey_question_id));
      return <section className="uk-card uk-card-default uk-card-body uk-margin" key={q.survey_question_id}>
        <h3>{q.question}</h3>
        {q.question_type === "item-list" ? <>
          {!answer?.value?.items?.length ? <p>No items selected</p> : <ul className="uk-list uk-list-divider">{answer.value.items.map((item) => <li key={item.line_id}>
            <strong>{item.name}</strong>{item.quantity != null && ` × ${item.quantity}`}{item.unit && ` ${item.unit}`}
            {item.preference && <div style={{ whiteSpace: "pre-wrap" }}>{item.preference}</div>}
          </li>)}</ul>}
          {answer?.value?.notes && <p style={{ whiteSpace: "pre-wrap" }}>Notes: {answer.value.notes}</p>}
        </> : <p style={{ whiteSpace: "pre-wrap" }}>{answerText(result.answers, q.survey_question_id) || "Not answered"}</p>}
      </section>;
    })}
  </div>;
}
